import ActionType from 'actions/ActionType'

export default (state = false, action) => {
	switch (action.type) {
		case ActionType.Inbox.TOGGLE_MESSAGE_MENU:
			if (typeof action.payload === 'boolean') {
				return action.payload
			}
			return !state
		case ActionType.Inbox.SELECT_CONVERSATION:
			return false
		default:
			return state
	}
}
